package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class MediaUploadRequest(
    val dataUrl: String,
    val folderKey: String? = null,
    val mediaType: String = "photos"
)

@Serializable
data class MediaUploadResponse(
    val folderKey: String,
    val url: String
)
